import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";
import Map from "../Map/Map";
import ListRatesComponent from "../Views/ListRatesComponent";
import AddRatesComponent from "../Views/AddRatesComponent";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, CardTitleBar, CardBody, FormField, TextInput, Select, StatusBadge, Spinner, Tabs, DataTable} from "../UI";
import {tokens} from "../../theme/tokens";

const InfoTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        font-size: ${tokens.typography.size.base};
        border-bottom: 1px solid ${tokens.colors.divider};
        vertical-align: middle;
    }
    td:first-child { color: ${tokens.colors.muted}; width: 45%; }
    td:last-child { color: ${tokens.colors.heading}; font-weight: ${tokens.typography.weight.semibold}; }
    tr:last-child td { border-bottom: 0; }
`;

const AreaDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({title: ''});
    const [mapCentre, setMapCentre] = useState({});
    const [name, setName] = useState('');
    const [centreLat, setCentreLat] = useState(0);
    const [centreLng, setCentreLng] = useState(0);
    const [radius, setRadius] = useState(10);
    const [countryId, setCountryId] = useState('');
    const [countries, setCountries] = useState([]);
    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(0);
    const [pendingStatus, setPendingStatus] = useState(null);
    const [tab, setTab] = useState("details");

    const [requestTypeList, setRequestTypeList] = useState([]);
    const [requestTypeName, setRequestTypeName] = useState('');
    const [requestTypeTime, setRequestTypeTime] = useState('');
    const [requestTypeStatus, setRequestTypeStatus] = useState(1);
    const [requestTypeDes, setRequestTypeDes] = useState('');

    const [meansTypeList, setMeansTypeList] = useState([]);
    const [meansTypeName, setMeansTypeName] = useState('');
    const [meansTypeDes, setMeansTypeDes] = useState('');

    const [peakHoursList, setPeakHoursList] = useState([]);
    const [peakStart, setPeakStart] = useState('');
    const [peakEnd, setPeakEnd] = useState('');

    const [requestType, setRequestType] = useState('');
    const [meansType, setMeansType] = useState('');
    const [peakRate, setPeakRate] = useState('');
    const [normalRate, setNormalRate] = useState('');

    const [regionList, setRegionList] = useState([]);
    const [nameRegion, setNameRegion] = useState('');
    const [centreLatRegion, setCentreLatRegion] = useState('');
    const [centreLngRegion, setCentreLngRegion] = useState('');
    const [radiusRegion, setRadiusRegion] = useState('');

    const requestTypeColumns = [
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
            cell: row => <div><Link to={"/request_types/" + row.id}>{row.name}</Link></div>,
        },
        {
            name: 'Description',
            selector: 'description',
            sortable: true,
        },
        {
            name: 'Min hrs',
            selector: 'expected_time',
            sortable: true,
        },
        {
            name: 'Mode',
            cell: row => row.can_be_handed_over ? "Standard" : "Express",
        },
        {
            name: 'Status',
            sortable: true,
            cell: row => <StatusBadge tone={row.status === 1 ? "success" : "neutral"}>{row.status === 1 ? "ACTIVE" : "INACTIVE"}</StatusBadge>,
        },
    ]

    const meansTypeColumns = [
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
            cell: row => <div><Link to={"/means/" + row.id}>{row.name}</Link></div>,
        },
        {
            name: 'Description',
            selector: 'description',
            sortable: true,
        },
        {
            name: 'Status',
            sortable: true,
            cell: row => <StatusBadge tone={row.status === 1 ? "success" : "neutral"}>{row.status === 1 ? "ACTIVE" : "INACTIVE"}</StatusBadge>,
        },
    ]

    const peakHoursColumns = [
        {
            name: 'Start hour (H)',
            selector: 'start',
            sortable: true,
        },
        {
            name: 'End hour (H)',
            selector: 'end',
            sortable: true,
        },
        {
            name: '',
            cell: row => <Button variant="danger" size="sm"
                                 onClick={e => deletePeakHours(row.id)}>Delete</Button>,
        },
    ]


    const regionsColumns = [
        {
            name: 'Name',
            selector: 'title',
            sortable: true,
            cell: row => <div><Link to={"/regions/" + row.id}>{row.title}</Link></div>,
        },
        {
            name: 'Centre Lat',
            selector: 'centre_lat',
        },
        {
            name: 'Centre Lng',
            selector: 'centre_lng',
        },
        {
            name: 'Radius in KM',
            selector: 'radius',
        },
        {
            name: 'Status',
            sortable: true,
            cell: row => <StatusBadge tone={row.status === 1 ? "success" : "neutral"}>{row.status === 1 ? "ACTIVE" : "INACTIVE"}</StatusBadge>,
        },
    ]

    const {id} = props.match.params;

    const load = () => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.AREA_DETAIL, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    setName(res.data.title);
                    setRadius(res.data.radius);
                    setCountryId(res.data.country_id || '');
                    setStartTime(res.data.start_time || 0)
                    setEndTime(res.data.end_time || 0)

                    setCentreLat(res.data.centre_lat);
                    setCentreLng(res.data.centre_lng);
                    setMapCentre({
                        lat: res.data.centre_lat,
                        lng: res.data.centre_lng
                    })
                    updateDocumentTitle(res.data.title)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    const loadCountries = () => {
        postData(Endpoints.COUNTRY_LIST, new FormData())
            .then(res => res.json())
            .then(res => {
                if (res.success === 1 && Array.isArray(res.data)) {
                    setCountries(res.data);
                }
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        load()
        loadCountries()
        loadRequestTypes()
        loadMeansTypes()
        loadPeakHours()
        loadRegions()
    }, []);

    function updateStatus(number, reason) {
        let data = new FormData();
        data.append("id", id);
        data.append("status", number);
        data.append("reason", reason);

        setIsLoading(true);
        postData(Endpoints.AREA_UPDATE_STATUS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function updateDetails(e) {
        e.preventDefault()

        let data = new FormData();
        data.append("id", id);
        data.append("name", name)
        data.append("centre_lat", centreLat)
        data.append("centre_lng", centreLng)
        data.append("radius", radius)
        data.append("country_id", countryId)
        data.append("start_time", startTime)
        data.append("end_time", endTime)

        setIsLoading(true)
        postData(Endpoints.AREA_UPDATE_DETAILS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadRequestTypes() {
        let data = new FormData();
        data.append("area_id", id);
        setIsLoading(true)
        postData(Endpoints.REQUEST_TYPE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRequestTypeList(res.data || []);
                    if (res.data.length > 0) setRequestType(res.data[0].id)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function addRequestType(e) {
        e.preventDefault()

        let data = new FormData();
        data.append("area_id", id);
        data.append("name", requestTypeName)
        data.append("expected_time", requestTypeTime)
        data.append("status", requestTypeStatus)
        data.append("description", requestTypeDes)


        setIsLoading(true)
        postData(Endpoints.REQUEST_TYPE_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    setRequestTypeName('');
                    setRequestTypeDes('')
                    loadRequestTypes()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function deleteRequestType(id) {

        let data = new FormData();
        data.append("id", id);

        setIsLoading(true)
        postData(Endpoints.REQUEST_TYPE_DELETE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    loadRequestTypes()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadMeansTypes() {
        let data = new FormData();
        data.append("area_id", id);
        setIsLoading(true)
        postData(Endpoints.MEANS_TYPE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setMeansTypeList(res.data || []);
                    if (res.data.length > 0) setMeansType(res.data[0].id)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function addMeansType(e) {
        e.preventDefault()

        let data = new FormData();
        data.append("area_id", id);
        data.append("name", meansTypeName)
        data.append("description", meansTypeDes)

        setIsLoading(true)
        postData(Endpoints.MEANS_TYPE_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    setMeansTypeName('');
                    setMeansTypeDes('')
                    loadMeansTypes()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadPeakHours() {
        let data = new FormData();
        data.append("area_id", id);
        setIsLoading(true)
        postData(Endpoints.PEAK_HOURS_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setPeakHoursList(res.data || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function addPeakHours(e) {
        e.preventDefault()

        let data = new FormData();
        data.append("area_id", id);
        data.append("start", peakStart)
        data.append("end", peakEnd)

        setIsLoading(true)
        postData(Endpoints.PEAK_HOURS_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    setPeakStart('');
                    setPeakEnd('');
                    loadPeakHours()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function deletePeakHours(id) {

        let data = new FormData();
        data.append("id", id);

        setIsLoading(true)
        postData(Endpoints.PEAK_HOURS_DELETE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.data, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    loadPeakHours()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadRegions() {
        let data = new FormData();
        data.append("area_id", id);
        setIsLoading(true)
        postData(Endpoints.REGION_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRegionList(res.data || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function addRegion(e) {
        e.preventDefault()

        let data = new FormData();
        data.append("area_id", id);
        data.append("name", nameRegion)
        data.append("centre_lat", centreLatRegion)
        data.append("centre_lng", centreLngRegion)
        data.append("radius", radiusRegion)

        setIsLoading(true)
        postData(Endpoints.REGION_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    setNameRegion('')
                    setCentreLatRegion('')
                    setCentreLngRegion('')
                    setRadiusRegion('')
                    loadRegions()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    return (
        <PageLayout
            title={item.title}
            actions={item.title !== '' ? (
                <div style={{display: "flex", alignItems: "center", gap: tokens.spacing[2]}}>
                    {isLoading && <Spinner size={18}/>}
                    {!isLoading &&
                    <Button
                        variant={item.status === 1 ? "danger" : "primary"}
                        onClick={() => setPendingStatus(item.status === 1 ? 0 : 1)}>
                        {item.status === 1 ? "Deactivate" : "Activate"}
                    </Button>
                    }
                    <Link to="/areas">
                        <Button variant="outline">Back to areas</Button>
                    </Link>
                </div>
            ) : null}
        >
            {item.title !== '' &&
            <React.Fragment>
                <Tabs
                    tabs={[
                        {key: "details", label: "Details"},
                        {key: "regions", label: "Regions", count: regionList.length},
                        {key: "requests", label: "Request Types", count: requestTypeList.length},
                        {key: "means", label: "Means Types", count: meansTypeList.length},
                        {key: "peakhours", label: "Peak Hours", count: peakHoursList.length},
                        {key: "rates", label: "Rates"},
                    ]}
                    value={tab}
                    onChange={setTab}
                />

                {tab === "details" &&
                <div className="row">
                    <div className="col-md-6">
                        <Card padded style={{marginBottom: tokens.spacing[4]}}>
                            <InfoTable>
                                <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>{item.title}</td>
                                </tr>
                                <tr>
                                    <td>Centre lat</td>
                                    <td>{item.centre_lat}</td>
                                </tr>
                                <tr>
                                    <td>Centre lng</td>
                                    <td>{item.centre_lng}</td>
                                </tr>
                                <tr>
                                    <td>Radius in KM</td>
                                    <td>{item.radius}</td>
                                </tr>
                                <tr>
                                    <td>Starting working hour</td>
                                    <td>{item.start_time}H</td>
                                </tr>
                                <tr>
                                    <td>Closing working hour</td>
                                    <td>{item.end_time}H</td>
                                </tr>
                                <tr>
                                    <td>Status</td>
                                    <td>
                                        <StatusBadge tone={item.status === 0 ? "neutral" : "success"}>
                                            {item.status === 0 ? "INACTIVE" : "ACTIVE"}
                                        </StatusBadge>
                                    </td>
                                </tr>
                                </tbody>
                            </InfoTable>
                        </Card>

                        <Map showCircle={true} mapCentre={mapCentre} radius={item.radius}/>

                    </div>
                    <div className="col-md-6">
                        <Card padded={false}>
                            <CardTitleBar title="Update area"/>
                            <CardBody>
                                <form onSubmit={updateDetails}>

                                    <FormField label="Name" required htmlFor="areaName">
                                        <TextInput id="areaName"
                                                   type="text"
                                                   required={true}
                                                   placeholder="Name"
                                                   value={name}
                                                   onChange={e => setName(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Country" required htmlFor="areaCountry">
                                        <Select id="areaCountry"
                                                required
                                                value={countryId}
                                                onChange={e => setCountryId(e.target.value)}
                                        >
                                            <option value="">Select a country</option>
                                            {countries.map(c => (
                                                <option key={c.id} value={c.id}>{c.name} ({c.currency})</option>
                                            ))}
                                        </Select>
                                    </FormField>

                                    <FormField label="Centre latitude" required htmlFor="areaLat">
                                        <TextInput id="areaLat"
                                                   type="text"
                                                   required={true}
                                                   placeholder="Centre latitude"
                                                   value={centreLat}
                                                   onChange={e => setCentreLat(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Centre longitude" required htmlFor="areaLng">
                                        <TextInput id="areaLng"
                                                   type="text"
                                                   required={true}
                                                   placeholder="Centre longitude"
                                                   value={centreLng}
                                                   onChange={e => setCentreLng(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Radius in KM" required htmlFor="areaRadius">
                                        <TextInput id="areaRadius"
                                                   type="number"
                                                   required={true}
                                                   placeholder="Radius"
                                                   value={radius}
                                                   onChange={e => setRadius(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Working hours (Start) - Number between 0 - 23" required htmlFor="areaStart">
                                        <TextInput id="areaStart"
                                                   type="number"
                                                   required={true}
                                                   placeholder="Start time"
                                                   value={startTime}
                                                   onChange={e => setStartTime(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Working hours (End) - Number between 0 - 23" required htmlFor="areaEnd">
                                        <TextInput id="areaEnd"
                                                   type="number"
                                                   required={true}
                                                   placeholder="End time"
                                                   value={endTime}
                                                   onChange={e => setEndTime(e.target.value)}
                                        />
                                    </FormField>

                                    <Button type="submit" loading={isLoading}>Update</Button>

                                </form>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                }
                {tab === "requests" &&
                <div className="row">
                    <div className="col-md-6">
                        <Card padded={false}>
                            <DataTable
                                columns={requestTypeColumns}
                                data={requestTypeList}
                                pointerOnHover={true}
                                noHeader={true}
                            />
                        </Card>
                    </div>
                    <div className="col-md-6">
                        <Card padded={false}>
                            <CardTitleBar title="Add new request type"/>
                            <CardBody>
                                <form onSubmit={addRequestType}>
                                    <FormField label="Name" required htmlFor="rtName">
                                        <TextInput id="rtName"
                                                   type="text"
                                                   required={true}
                                                   placeholder="Name"
                                                   value={requestTypeName}
                                                   onChange={e => setRequestTypeName(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Description" required htmlFor="rtDes">
                                        <TextInput id="rtDes"
                                                   type="text"
                                                   required={true}
                                                   placeholder="Name"
                                                   value={requestTypeDes}
                                                   onChange={e => setRequestTypeDes(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Expected duration in hours" required htmlFor="rtTime">
                                        <TextInput id="rtTime"
                                                   type="number"
                                                   required={true}
                                                   value={requestTypeTime}
                                                   onChange={e => setRequestTypeTime(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Select a mode" htmlFor="rtMode">
                                        <Select id="rtMode"
                                                value={requestTypeStatus}
                                                onChange={({target}) => setRequestTypeStatus(target.value)}>
                                            <option value={1}>Standard mode - Riders can hand over requests
                                                to each other
                                            </option>
                                            <option value={0}>Express mode - Only one rider is allowed to
                                                handle each request
                                            </option>
                                        </Select>
                                    </FormField>

                                    <Button type="submit" loading={isLoading}>Add</Button>
                                </form>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                }
                {tab === "means" &&
                <div className="row">
                    <div className="col-md-6">
                        <Card padded={false}>
                            <DataTable
                                columns={meansTypeColumns}
                                data={meansTypeList}
                                pointerOnHover={true}
                                noHeader={true}
                            />
                        </Card>
                    </div>
                    <div className="col-md-6">
                        <Card padded={false}>
                            <CardTitleBar title="Add new means type"/>
                            <CardBody>
                                <form onSubmit={addMeansType}>
                                    <FormField label="Name" required htmlFor="mtName">
                                        <TextInput id="mtName"
                                                   type="text"
                                                   required={true}
                                                   placeholder="Name"
                                                   value={meansTypeName}
                                                   onChange={e => setMeansTypeName(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Description" required htmlFor="mtDes">
                                        <TextInput id="mtDes"
                                                   type="text"
                                                   required={true}
                                                   placeholder="Name"
                                                   value={meansTypeDes}
                                                   onChange={e => setMeansTypeDes(e.target.value)}
                                        />
                                    </FormField>

                                    <Button type="submit" loading={isLoading}>Add</Button>
                                </form>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                }
                {tab === "peakhours" &&
                <div className="row">
                    <div className="col-md-6">
                        <Card padded={false}>
                            <DataTable
                                columns={peakHoursColumns}
                                data={peakHoursList}
                                pointerOnHover={true}
                                noHeader={true}
                            />
                        </Card>
                    </div>
                    <div className="col-md-6">
                        <Card padded={false}>
                            <CardTitleBar title="Add new peak hour"/>
                            <CardBody>
                                <form onSubmit={addPeakHours}>

                                    <FormField label="Start hour (24hr)" required htmlFor="peakStart">
                                        <TextInput id="peakStart"
                                                   type="number"
                                                   max={23}
                                                   required={true}
                                                   placeholder="Start"
                                                   value={peakStart}
                                                   onChange={e => setPeakStart(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="End hour (24hr)" required htmlFor="peakEnd">
                                        <TextInput id="peakEnd"
                                                   type="number"
                                                   max={23}
                                                   required={true}
                                                   placeholder="End"
                                                   value={peakEnd}
                                                   onChange={e => setPeakEnd(e.target.value)}
                                        />
                                    </FormField>

                                    <Button type="submit" loading={isLoading}>Add</Button>

                                </form>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                }
                {tab === "rates" &&
                <div className="row">
                    <div className="col-md-8">
                        <ListRatesComponent area={id}/>
                    </div>
                    <div className="col-md-4">
                        <AddRatesComponent area={id}/>
                    </div>
                </div>
                }
                {tab === "regions" &&
                <div className="row">
                    <div className="col-md-8">
                        <Card padded={false}>
                            <DataTable
                                columns={regionsColumns}
                                data={regionList}
                                pointerOnHover={true}
                                noHeader={true}
                                onRowClicked={e => {
                                    history.push('/regions/' + e.id);
                                }}
                            />
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <Card padded={false}>
                            <CardTitleBar title="Add new region"/>
                            <CardBody>
                                <form onSubmit={addRegion}>
                                    <FormField label="Name" required htmlFor="regName">
                                        <TextInput id="regName"
                                                   type="text"
                                                   required
                                                   placeholder="Name"
                                                   value={nameRegion}
                                                   onChange={e => setNameRegion(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Centre latitude" required htmlFor="regLat">
                                        <TextInput id="regLat"
                                                   type="text"
                                                   required
                                                   placeholder="Centre latitude"
                                                   value={centreLatRegion}
                                                   onChange={e => setCentreLatRegion(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Centre longitude" required htmlFor="regLng">
                                        <TextInput id="regLng"
                                                   type="text"
                                                   required
                                                   placeholder="Centre longitude"
                                                   value={centreLngRegion}
                                                   onChange={e => setCentreLngRegion(e.target.value)}
                                        />
                                    </FormField>

                                    <FormField label="Radius in KM" required htmlFor="regRadius">
                                        <TextInput id="regRadius"
                                                   type="text"
                                                   required
                                                   placeholder="Radius"
                                                   value={radiusRegion}
                                                   onChange={e => setRadiusRegion(e.target.value)}
                                        />
                                    </FormField>

                                    <Button type="submit" loading={isLoading}>Add</Button>

                                </form>
                            </CardBody>
                        </Card>
                    </div>
                </div>
                }
            </React.Fragment>
            }
            {pendingStatus !== null &&
            <ReasonCaptureModal
                title={pendingStatus === 0 ? "Deactivate area" : "Activate area"}
                onCancel={() => setPendingStatus(null)}
                onConfirm={reason => { updateStatus(pendingStatus, reason); setPendingStatus(null); }}
            />
            }
        </PageLayout>
    )
};


export default AreaDetails
